import { createAction, props } from '@ngrx/store';

export const PagedGridAnalyticsActions = {
  GridRendered: createAction(
    '[Paged grid analytics] grid rendered',
    props<{ instanceId: string; renderingTimeMs: number }>(),
  ),
};
